import React, { useEffect, useState } from 'react';
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import carewindow_blue from '../assets/images/carewindow_blue.png';
import { hasValue, ProcessAPIError } from '../utils/common_functions';
import '../assets/css/NavMenu.css';
import { FaBars, FaUser } from "react-icons/fa";
import { CreateCustomerSession } from '../utils/apis';

const NavMenu = () => {

    const [DisplayName, setDisplayName] = useState('');
    const [email, setEmailId] = useState('');
    const [ProfileImage, setProfileImage] = useState('');

    const useIsMobile = () => {
        const [isMobile, setIsMobile] = useState(false);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 768);
            };

            handleResize();
            window.addEventListener('resize', handleResize);

            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return isMobile;
    };

    useEffect(() => {
        GetDisplayDetails();
    }, []);

    const GetDisplayDetails = () => {
        let obj = JSON.parse(localStorage.getItem('auth'));
        setEmailId(obj?.email || '');
        setDisplayName(obj?.name || '');
        setProfileImage(obj?.profile_pic || '');
    }

    const LogOut = () => {
        const isConfirmed = window.confirm('Are you sure you want to Logout?');
        if (isConfirmed) {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = "/";
        }
    }

    const GenerateCustomerSession = async () => {
        try {
            let obj = JSON.parse(localStorage.getItem('auth'));

            let resp = await CreateCustomerSession(obj.device_id);
            window.location.href = resp.data.url;
        }
        catch (error) {
            alert(ProcessAPIError(error));
        }
    }

    const LoadNavLink = () => {
        const isMobile = useIsMobile();

        return (
            <Nav className={isMobile === false ? "me-auto set_right align-items-center" : "me-auto set_right"}>
                <Nav.Link href="/features">Home</Nav.Link>
                <Nav.Link href="#" onClick={(e) => { e.preventDefault(); GenerateCustomerSession(); }}>My Subscription</Nav.Link>
                {isMobile === false &&
                    <>
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <NavDropdown title={DisplayName} id="user_menu">
                                    <NavDropdown.Item href="#action/3.3">{email}</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="#action/3.3">
                                        <Nav.Link className="cw_menu_logout" href="#" onClick={(e) => { e.preventDefault(); LogOut(); }}>Logout</Nav.Link>
                                    </NavDropdown.Item>


                                    {/*<NavDropdown.Item href="#action/3.4">*/}
                                    {/*    Separated link*/}
                                    {/*</NavDropdown.Item>*/}
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </>
                }
            </Nav>
        )
    }

    return (

        //<Nav.Link href="#">
        //                    <strong>{DisplayName}</strong>
        //                </>
        //                <Nav.Link href="#">
        //                    {
        //                        hasValue(ProfileImage) ?
        //                            <>
        //                                <img src={`data:image/png;base64, ${ProfileImage}`} alt="Profile" className="rounded" width="28" />
        //                            </>
        //                            :
        //                            <>
        //                                <FaUser size={28} />
        //                            </>
        //                    }
        //                </Nav.Link>

        <Navbar expand="lg" className="bg-body-tertiary" sticky="top">
            <Container>
                <Navbar.Brand href="#home"><img src={carewindow_blue} alt="CareWindow" width="150" /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" >
                    {hasValue(ProfileImage) ?
                        <>
                            <img src={`data:image/png;base64, ${ProfileImage}`} alt="Profile" className="rounded" width="28" />
                        </>
                        :
                        <>
                            <FaUser size={28} />
                        </>
                    }
                    <FaBars className="ms-3" size={18} />
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <LoadNavLink />
                </Navbar.Collapse>
            </Container>
        </Navbar>
        //<Navbar bg="white" className="border-bottom shadow-sm px-3" sticky="top">
        //    <Navbar.Brand href="#">
        //        <img src={carewindow_blue} alt="CareWindow" width="150" />
        //    </Navbar.Brand>
        //    <Navbar.Toggle aria-controls="basic-navbar-nav" />
        //    <Navbar.Collapse id="basic-navbar-nav">
        //        <Nav className="me-auto">
        //            <Nav.Link href="/features">Home</Nav.Link>
        //            <Nav.Link href="#link">Subscription</Nav.Link>
        //        </Nav>
        //    </Navbar.Collapse>
        //    <Nav className="ms-auto">
        //        {hasValue(ProfileImage) ?
        //            <>
        //                <img src={`data:image/png;base64, ${ProfileImage}`} alt="Profile" className="rounded" width="40" />
        //            </>
        //            :
        //            <>
        //                <div className="mt-2"><strong>{DisplayName}</strong></div>
        //            </>
        //        }
        //        <FaBars className="ms-3 mt-3" size={18} />
        //    </Nav>
        //</Navbar>
    );
}

export default NavMenu;